import { ApplicationRef, Injectable, PLATFORM_ID, inject } from "@angular/core";
import { DOCUMENT, isPlatformBrowser } from "@angular/common";
import { SwUpdate } from "@angular/service-worker";
import { first } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class PromptUpdate {
  private document = inject<Document>(DOCUMENT);
  private platformId = inject(PLATFORM_ID);
  private appRef = inject(ApplicationRef);
  private swUpdate = inject(SwUpdate);

  constructor() {
    const platformId = this.platformId;
    const appRef = this.appRef;

    if (isPlatformBrowser(platformId)) {
      const appIsStable$ = appRef.isStable.pipe(
        first((isStable) => isStable === true),
      );

      appIsStable$.subscribe(async () => {
        try {
          const updateAvailable = await this.swUpdate.checkForUpdate();

          if (
            updateAvailable &&
            confirm(
              "Une nouvelle version du site est disponible, souhaitez-vous recharger la page afin de l'obtenir ?",
            )
          ) {
            this.swUpdate
              .activateUpdate()
              .then(() => this.document.location.reload());
          }
        } catch {
          // Service workers not available (e.g., in tests)
        }
      });
    }
  }
}
